import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfigService } from '@core/appconfig.service';
import { AuthenticationService } from '@core/authentication.service';
import { LogoParams } from '@models/logo-params';
import { CompanyCode } from '@shared/enums/company-code';
import { LogoHelpers } from '@shared/logo-helpers';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';
import { interval, Subscription } from 'rxjs';
import { mergeMap, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'zbp-branded-site-down',
  templateUrl: './branded-site-down.component.html',
  styleUrls: ['./branded-site-down.component.scss'],
  standalone: false
})
export class BrandedSiteDownComponent implements OnDestroy, OnInit {
  protected readonly zbpIconNames = zbpIconNames;
  message: string = '';
  title: string = 'Sorry, we\'re down for maintenance.';
  isZB: boolean = false;
  zbLink: string = 'https://www.zaner-bloser.com';
  up = true;
  logoParams: LogoParams;
  footerItemHoverColor: string = '#E00833';
  private interval = false;
  private subscription: Subscription;

  constructor(
    private authService: AuthenticationService,
    private appConfig: AppConfigService,
    private router: Router
  ) { }

  ngOnInit() {
    this.isZB = this.appConfig.loginBrand === CompanyCode.ZBPortal;
    this.message = this.isZB ? `My ZB Portal is currently unavailable due to unscheduled maintenance.
      We apologize for the inconvenience.`
      : 'The portal will be back up soon. Please check back later.';
    this.logoParams = LogoHelpers.setLogoParams(this.isZB);

    this.appConfig.siteStatus.subscribe((up: boolean) => {
      this.up = up;
      if (this.up) {
        // Redirects back home if the site is up again.
        this.router.navigateByUrl('/');
      } else if (!this.interval) {
        this.checkStatus();
      }
    });
  }

  ngOnDestroy() {
    this.interval = false;
    if (this.subscription) {
      // Cleans up the subscription on route change otherwise the interval will continue to make
      // requests to check the site status even after the component is destroyed.
      this.subscription.unsubscribe();
      this.subscription.remove(this.subscription);
    }
  }

  private checkStatus() {
    this.interval = true;
    this.subscription = interval(120000)
      .pipe(
        takeWhile(() => !this.up),
        mergeMap(() => this.authService.checkTokenStatus()),
      )
      .subscribe((state: boolean) => {
        this.appConfig.setSiteStatus(state);
      });
  }
}
